import type { BBox, LngLat } from '@okmaps/shared';
import { baseApi } from './baseApi.js';

export interface GeocodeMatch {
  readonly label: string;
  readonly center: LngLat;
  readonly kind: 'address' | 'county' | 'quad' | 'zip' | 'city';
  readonly bbox?: BBox;
}

/**
 * Place search.
 *
 * Addresses resolve through the US Census Geocoder, which is free, requires no
 * key, is authoritative for US addresses, and avoids adding a metered Esri
 * geocoding dependency. Counties, quads, ZIPs and cities resolve locally
 * against layers OGI already publishes, so those lookups cost one cached
 * request rather than a third-party call.
 */
export const geocodeApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    geocode: build.query<readonly GeocodeMatch[], string>({
      query: (text) => ({ url: 'geocode', params: { q: text } }),
      keepUnusedDataFor: 300,
    }),
  }),
});

export const { useGeocodeQuery, useLazyGeocodeQuery } = geocodeApi;
